var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"node-tree"},[_c('span',[_c('a',{attrs:{"target":"_blank","href":'services#openId='+ _vm.node.id}},[_vm._v(" "+_vm._s(_vm.node.name))])]),_vm._v(" "),(_vm.node.children && _vm.node.children.length)?_c('ul',_vm._l((_vm.node.children),function(child){return _c('node',{key:child.id,attrs:{"node":child}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }